<script lang="ts">
import { defineComponent } from 'vue'

import { HandballStatId } from '@collector/sportsapi-client-legacy'
import ParticipantComponent from '@mobile/components/Participant/Participant.vue'
import MainResult from '@mobile/views/Relation/Shared/LiveView/LiveViewHeader/MainResult.vue'
import Stat from '@mobile/views/Relation/Shared/LiveView/LiveViewHeader/Stat.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import EmptyNetLiveViewStat from './LiveViewHeaderStats/EmptyNetLiveViewStat.vue'
import PowerPlayLiveViewStat from './LiveViewHeaderStats/PowerPlayLiveViewStat.vue'

export default defineComponent({
  components: {
    MainResult,
    ParticipantComponent,
    EmptyNetLiveViewStat,
    PowerPlayLiveViewStat,
    Stat,
  },
  setup() {
    const {
      probableFirstParticipant,
      probableLinkedFirstParticipant,
      probableSecondParticipant,
      probableLinkedSecondParticipant,
    } = useEventInjections()

    return {
      HandballStatId,
      probableFirstParticipant,
      probableLinkedFirstParticipant,
      probableSecondParticipant,
      probableLinkedSecondParticipant,
    }
  },
})
</script>

<template>
  <div class="flex items-center space-x-2 px-2 py-1">
    <div
      class="flex h-8 w-32 items-center justify-start md:w-36 lg:w-48 xl:w-56"
    >
      <ParticipantComponent :participant="probableFirstParticipant" />
    </div>
    <div class="flex h-8 flex-1 flex-row items-center justify-between">
      <div class="flex items-center space-x-2">
        <MainResult
          :probableLinkedParticipant="probableLinkedFirstParticipant"
        />
        <EmptyNetLiveViewStat :participant="probableFirstParticipant" />
        <PowerPlayLiveViewStat :participant="probableFirstParticipant" />
      </div>
      <Stat :statId="HandballStatId.TwoMinutesSuspensions" />
      <Stat :statId="HandballStatId.PenaltyGoals" />
      <Stat :statId="HandballStatId.Penalties" />
      <div class="flex items-center space-x-2">
        <PowerPlayLiveViewStat :participant="probableSecondParticipant" />
        <EmptyNetLiveViewStat :participant="probableSecondParticipant" />
        <MainResult
          :probableLinkedParticipant="probableLinkedSecondParticipant"
        />
      </div>
    </div>
    <div
      class="flex h-8 w-32 flex-row items-center justify-end md:w-36 lg:w-48 xl:w-56"
    >
      <ParticipantComponent
        :participant="probableSecondParticipant"
        :reverse="true"
      />
    </div>
  </div>
</template>
